// @flow

import { open } from 'window';

import assert from 'assert';

import _ from 'lodash';
import Q from 'q';

import { Cancellation } from 'promise-cancellation';

import type { LogContextInterface } from 'log-context';

import moment from 'moment';
const { duration } = moment;

import server from 'server';
import { default as server2, authRoute } from 'server2';

import modals from 'modals';

class EsiaAuthWindow {
	_getAuthLink (logContext?: LogContextInterface) {
		return server2.any.rest
			.withLogContext(logContext)
			.get([
				authRoute.prefix,
				authRoute.links,
				authRoute.esia,
			])
			.then(({ responseJSON: { Data: { EsiaLink } } }) => EsiaLink);
	}

	_clearEsiaAuthStatus () {
		return server.my.cmsapi.lk.esia.authStatus.clear();
	}

	_getEsiaAuthStatus () {
		return server.my.cmsapi.lk.esia.authStatus.get();
	}

	_pollEsiaAuthStatus (cancellationToken: any) {
		cancellationToken = cancellationToken || _.identity;

		const poll = () => {
			return this._getEsiaAuthStatus()
				.then(cancellationToken)
				.then(({ responseJSON: { Status, Data } }) => {
					if (Status === 'None') {
						return Q.delay(duration(3, 'second').asMilliseconds())
							.then(poll);
					}

					assert(Status === 'Success');

					return Data;
				});
		};

		return poll();
	}

	_performAuthInWindow (window: WindowProxy,
						  cancellationToken: any,
						  logContext?: LogContextInterface | Promise<LogContextInterface>) {
		return Q()
			.then(() => logContext)
			.then(logContext => this._getAuthLink(logContext))
			.then(link => {
				const clearPromise = this._clearEsiaAuthStatus();
				return Q.all([link, clearPromise]);
			})
			.spread(link => {
				window.location.replace(link);
				return this._pollEsiaAuthStatus(cancellationToken);
			});
	}

	open (logContext: LogContextInterface | Promise<LogContextInterface>) {
		const window = open('', '_blank');

		const cancellation = new Cancellation();

		return modals.prompt.waitOrSkip({
			title: 'Ожидаем ответа от Госуслуг (ЕСИА)',
			message: 'Пожалуйста, пройдите авторизацию в открывшейся вкладке',
			waitFor: this._performAuthInWindow(window, cancellation.token, logContext),
		})
			.finally(() => {
				window.close();
				cancellation.cancel();
			});
	}
}

export const esiaAuthWindow = new EsiaAuthWindow;
